export const lineitemStates = 'LAUNCHED,AWAITING_APPROVAL,QA_APPROVED,AWAITING_APPROVAL_PAUSED,REJECTED,REJECTED_PAUSED,PAUSED,CLOSED,INVOICED,AWAITING_CLIENT_APPROVAL,COMPLETED'

export const pendingStates = [
    "launched",
    "awaiting_approval"
];

export const pendingQaStates = [
"pre_approve",
"pre_approved",
"post_approved"
];

/**
 * @param {number} start
 * @param {number} stop
 * @return {Array<number>}
 */
export const range = (start, stop) => new Array(stop - start).fill(0).map((v, i) => start + i);

/**
 * Accounts for integer
 * @param {string} string
 * @return {boolean}
 */
export const isNumber = string => /^\d+$/.test(string);

// Check if an input is a number
export const isNumeric = input => !isNaN(input) && input !== '';

/**
 *
 * @param {any} item
 * @return {boolean}
 */
export const exists = item => item !== null && item !== undefined;